<div class="ppl-mt20 p-4">
    @if (errorcodeEntries && errorcodeEntries.controls && errorcodeEntries.controls.length) {
    <form nz-form nz-row [formGroup]="staffErrorcodesForm" class="ppl-p0">
        <table class="table">
            <thead>
                <tr>
                    <th style="background-color: #a8e4e14d; width: 10%;">Code</th>
                    <th style="background-color: #a8e4e14d; width: 10%;">Description</th>
                    <th style="background-color: #a8e4e14d; width: 10%;">System Disposition</th>
                    @if(!disabled) {
                    <th style="background-color: #a8e4e14d; width: 10%;">Disposition</th>
                    }
                    <th style="background-color: #a8e4e14d; width: 10%;">Comments</th>
                    <th style="background-color: #a8e4e14d; width: 10%;">Reason</th>
                </tr>
            </thead>
            <tbody formArrayName="errorcodeEntries">
                <tr *ngFor="let entry of errorcodeEntries.controls; let i = index" [formGroupName]="i">
                    <td style="padding-left:24px;">
                        <span>{{ entry.get('code')?.value }}</span>
                    </td>
                    <td style="padding-left:24px; ">
                        <span>{{ entry.get('desc')?.value }}</span>
                    </td>
                    <td style="padding-left:24px; ">
                        <span>{{ entry.get('systemDisposition')?.value }}</span>
                    </td>
                    @if(!disabled) {
                    <td>
                        <div class="ppl-select">
                            <ppl-dropdown-select formControlName="dispositionLkp"
                            placeholder="Select disposition" [options]="getFilteredDispositionList(entry.value)"
                            [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'">
                            </ppl-dropdown-select>
                        </div>
                    </td>
                    }
                    <td>
                        <input nz-input formControlName="comments" id="comments" nzPlaceHolder="Enter comments" aria-label="Comments"/>
                        <div *ngIf="entry.get('comments')?.hasError('required') && entry.get('dispositionLkp')?.value"
                            class="error-message">
                            Comments are required.
                        </div>
                    </td>
                    <td>
                        <div class="ppl-select">
                            <ppl-dropdown-select formControlName="reasonLkp" placeholder="Select reason"
                            [options]="reasonList" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'">
                            </ppl-dropdown-select>
                        </div>
                        <div *ngIf="entry.get('reasonLkp')?.hasError('required') && entry.get('dispositionLkp')?.value"
                            class="error-message">
                            Reason is required.
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>

        <div class="custom-row" style="width: 100%;">
            <span *ngIf="staffErrorcodesForm.hasError('atLeastOneDisposition') && isSubmitted"
                class="error-message mr-4 pt-2">
                At least one disposition must be selected.
            </span>

            @if(!disabled) {
            <ppl-button (click)="onSave()" style="margin-right: 8px;" label="Save" icon="fa fa-check-circle"
                [customClass]="'primary-button'" [iconPosition]="'right'"></ppl-button>
            }
        </div>
    </form>
    } @else {
        <div class="alert alert-warning">No Records Found.</div>
    }
</div>